import React from 'react';
import Keycloak from 'keycloak-js';
import {AuthContext} from "../context/AuthContext";

type FETCH_STATUS = 'Idle' | 'Fetching' | 'Fetched' | 'Error';


const updateToken = (kc: Keycloak.KeycloakInstance, successCallback: any) =>
    kc.updateToken(5)
        .then(successCallback)
        .catch(kc.login);
;

export const headerFromToken = (token?: string) => {
    if (token) {
        return {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    } else {
        return {}
    }
};
/*
export const useUserLoader = async (url: string, header: any) => {
    const res = await fetch(url, header);
    if (!res.ok) {
        console.log('Res: ', res);
        throw new Error(res.status);
    }
    const response = await res.json();
    return response;
};
*/



export const useFetch = (input: RequestInfo, init?: RequestInit) => {
    const auth = React.useContext(AuthContext);
    const {token} = auth;
    const [status, setStatus] = React.useState('Idle' as FETCH_STATUS);
    const [data, setData] = React.useState([]);

    const header = headerFromToken(token?.token);


    React.useEffect(() => {

        const fetchData = async () => {
            setStatus('Fetching');
            const response = await fetch(input, {...init, ...header});
            const data = await response.json();
            setData(data);
            setStatus('Fetched');
        };

        if (token !== undefined) {
            updateToken(token, fetchData);
        }

    }, [input, init]);

    return [status, data];
};